import { defineAction } from '~/prix'
import { z } from 'zod'
import { roadMaintenanceDocumentStatus } from '../roadMaintenanceDocumentObject'
import roadMaintenanceDocumentConfirmAction from './roadMaintenanceDocumentConfirm.action.json' with { type: 'json' }

const roadMaintenanceDocumentConfirmDefinition = defineAction({
  ...roadMaintenanceDocumentConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: roadMaintenanceDocumentStatus,
  }),
  output: z.object({}),
})

export default roadMaintenanceDocumentConfirmDefinition
